module.exports = __webpack_public_path__ + "static/media/Dr-Eduardo-Nelli.13d14b4a.jpg";